import type * as models from 'pkg/api/models';
import type { AccountRelation } from 'pkg/api/models/account_relation';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';
import type { Scrubbable } from 'pkg/api/models/scrubbable';

export enum AccountNotificationSettings {
	Push = 'push',
	Email = 'email',
}

export enum AccountClearNotificationSettings {
	Push = '!push',
	Email = '!email',
}

export enum AccountFlags {
	CompletedFirstLogin = 'completed-first-login',
	OptOutAnalytics = 'optout-ga',
}

export enum AccountClearFlags {
	OptOutAnalytics = '!optout-ga',
}

export enum AccountHourFormat {
	'24h' = 0,
	'12h' = 1,
}

export interface Account
	extends Scrubbable, Record, Dateable, AllowedActionable {
	firstName: string;
	lastName: string;
	email: string;
	birthDate: string;
	profileImageUrl: string;
	languageCode: string;
	hourFormat: AccountHourFormat;
	countryCode: string;
	activitySummary: any;
	needsParentalConsent: boolean;
	parentalConsentEmail: string;
	parentalConsentGranted?: number;
	parentalConsentRevoked?: number;
	hasAppleAuth?: boolean;
	hasPassword?: boolean;
	hasEmail?: boolean;
	/** When the account proved it owns its email. */
	emailVerifiedAt?: number;
	/** A changed email waiting for the code sent to it. */
	pendingEmail?: string;
	trackingHash: any;
	helpScoutSignature: any;

	wards: AccountRelation[];
	flags: AccountFlags[] | AccountClearFlags;
	notificationSettings: AccountNotificationSettings[];

	users: models.user.User[];
	willBeDeletedAt: number;

	country?: models.country.Country;
}
